module.exports = __webpack_public_path__ + "fonts/lato-bold.85d339d9.ttf";